import { ProjectState } from '@/types';

const projectStoreSelector = (state: ProjectState) => ({
  currentProject: state.currentProject,
  actions: state.actions,
});

export const currentProjectSelector = (state: ProjectState) =>
  projectStoreSelector(state).currentProject;

export const currentProjectActionsSelector = (state: ProjectState) =>
  projectStoreSelector(state).actions;
